var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 8,
    viewBox: "0 0 28 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 0.539062C4.42826 0.539063 5.3185 0.907811 5.97487 1.56419C6.63125 2.22057 7 3.1108 7 4.03906C7 4.96732 6.63125 5.85756 5.97487 6.51394C5.3185 7.17031 4.42826 7.53906 3.5 7.53906C2.57174 7.53906 1.6815 7.17031 1.02513 6.51394C0.368749 5.85756 0 4.96732 0 4.03906C0 3.1108 0.368749 2.22057 1.02513 1.56419C1.6815 0.907811 2.57174 0.539062 3.5 0.539062ZM24.5 0.539062C25.4283 0.539063 26.3185 0.907811 26.9749 1.56419C27.6313 2.22057 28 3.1108 28 4.03906C28 4.96732 27.6313 5.85756 26.9749 6.51394C26.3185 7.17031 25.4283 7.53906 24.5 7.53906C23.5717 7.53906 22.6815 7.17031 22.0251 6.51394C21.3687 5.85756 21 4.96732 21 4.03906C21 3.1108 21.3687 2.22057 22.0251 1.56419C22.6815 0.907811 23.5717 0.539062 24.5 0.539062ZM14.3164 0.539062C15.2447 0.539063 16.1349 0.907811 16.7913 1.56419C17.4477 2.22057 17.8164 3.1108 17.8164 4.03906C17.8164 4.96732 17.4477 5.85756 16.7913 6.51394C16.1349 7.17031 15.2447 7.53906 14.3164 7.53906C13.3881 7.53906 12.4979 7.17031 11.8415 6.51394C11.1851 5.85756 10.8164 4.96732 10.8164 4.03906C10.8164 3.1108 11.1851 2.22057 11.8415 1.56419C12.4979 0.907811 13.3881 0.539062 14.3164 0.539062Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.384b688332342a3ef3f5b6aabbe12278.svg";
export { ForwardRef as ReactComponent };